<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智能充电轮播图 -->
    <ChargeBanner></ChargeBanner>
    <!-- 智能充电硬件详情 -->
    <ChargeDetails></ChargeDetails>
    <!-- 运营场景 -->
    <Operate></Operate>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../../components/mobile/components/BottomNav.vue";
import ChargeBanner from '../../../../components/mobile/Programme/ChargeComponents/ChargeBanner.vue'
import ChargeDetails from '../../../../components/mobile/Programme/ChargeComponents/ChargeDetails.vue'
import Operate from '../../../../components/mobile/Programme/ChargeComponents/Operate.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    ChargeBanner,
    ChargeDetails,
    Operate
  },
};
</script>

<style scoped>
</style>
